<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <p class="page_title">경찰청 YouTube</p>
                <div class="board_wrap bo_view_layer">
                    <div class="bo_view">
                        <div class="bo_view_tit">
                            <span class="tit">{{ content.title }}</span>
                            <span class="info">{{ content.date }}</span>
                        </div>
                        <div class="bo_view_content">
                            <template v-if="
                                content.fileLocation !== '' ||
                                content.fileLocation !== null ||
                                content.fileLocation !== undefined
                            ">
                                <img :src="content.fileLocation" v-if="!state.isVideoExt" />
                                <video :src="content.fileLocation" v-if="state.isVideoExt"></video>
                            </template>
                            <div class="bo_video" v-if="
                                content.youtubeLink !== '' ||
                                content.youtubeLink !== null ||
                                content.youtubeLink !== undefined
                            ">
                                <iframe width="100%" height="100%" :src="content.youtubeLink" frameborder="0"
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                        <div class="bo_list_btns">
                            <div class="prev" v-if="content.prevIdx !== null">
                                <span @click="prevPage(content.prevIdx)">
                                    <img src="@/assets/user/bo_arrow_u.png" />
                                    이전 글
                                </span>
                                <router-link to="#" @click="prevPage(content.prevIdx)">
                                    <p v-text="content.prevTitle"></p>
                                </router-link>
                            </div>
                            <div class="next" v-if="content.nextIdx !== null">
                                <span @click="nextPage(content.nextIdx)">
                                    <img src="@/assets/user/bo_arrow_d.png" />
                                    다음 글
                                </span>
                                <router-link to="#" @click="nextPage(content.nextIdx)">
                                    <p v-text="content.nextTitle"></p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="bo_view_btns">
                        <router-link to="#" class="list" @click="goToList">목록</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose"> </ModalComponent>
</template>
<script lang="ts" config>
import {
    HeaderLayout,
    GnbLayout,
    apiService,
    globalStore,
    onMounted,
    reactive,
    router,
    useRoute,
    watch,
    ModalComponent,
    formatDate,
} from "@/BaseComponent";
export default {
    components: {
        HeaderLayout,
        GnbLayout,
        ModalComponent,
    },
    setup() {
        const route = useRoute();
        const state = reactive({
            isNavOpen: true,
            isModalOpen: false as boolean,
            idx: route.params.idx as any,
            data: {} as any,
            isVideoExt: false as boolean,
        });
        const content = reactive({
            title: "" as string,
            date: "" as string,
            content: "" as any,
            youtubeLink: "" as string,
            fileLocation: "" as string,
            titleImg: "" as string,
            cntLike: 0 as number,
            cntBad: 0 as number,
            prevIdx: 0 as number | null,
            prevTitle: "" as string | null,
            nextIdx: 0 as number | null,
            nextTitle: "" as string | null,
            islike: false as boolean,
            isBad: false as boolean,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });

        const global = globalStore();
        state.isNavOpen = global.isNavOpen;

        onMounted(() => {
            getDetail(state.idx);
        });

        watch(route, () => {
            state.idx = route.params.idx;
            getDetail(state.idx);
        });

        const getDetail = async (idx: number) => {
            const res = await apiService.youtube.getDetail(idx);
            if (res.returnCode === 0) {
                content.title = res.data.title;
                content.date = formatDate(res.data.updateDate || res.data.createDate);
                content.content = res.data.content;
                content.cntLike = res.data.cntGood;
                content.cntBad = res.data.cntBad;
                content.islike = res.data.isGood;
                content.isBad = res.data.isBad;
                content.youtubeLink = res.data.youtubeLink;
                content.fileLocation = res.data.fileLocation;
                content.titleImg = res.data.fileLocation;
                content.prevIdx = res.data.prev ? res.data.prev.idx : null;
                content.prevTitle = res.data.prev ? res.data.prev.title : null;
                content.nextIdx = res.data.next ? res.data.next.idx : null;
                content.nextTitle = res.data.next ? res.data.next.title : null;
                checkFileExt();
            } else {
                modal.content = res.description;
                modal.confirm = "확인";
                state.isModalOpen = true;
                modal.actionCode = 1;
            }
        };

        const pushLike = async () => {
            const res = await apiService.youtube.like(state.idx);
            if (res.returnCode === 0) {
                getDetail(state.idx);
            }
        };
        const pushBad = async () => {
            const res = await apiService.youtube.bad(state.idx);
            if (res.returnCode === 0) {
                getDetail(state.idx);
            }
        };
        const prevPage = (prevIdx: number) => {
            router.push(`/youtube/detail/${prevIdx}`);
        };
        const nextPage = (nextIdx: number) => {
            router.push(`/youtube/detail/${nextIdx}`);
        };

        const goToList = () => {
            router.replace("/youtube/list");
        };

        const checkFileExt = () => {
            if (content.fileLocation) {
                const fileLen = content.fileLocation.length;
                const lastDot = content.fileLocation.lastIndexOf(".");
                const extName = content.fileLocation.substring(lastDot, fileLen).toLowerCase();
                switch (extName) {
                    case ".jpg": case ".jpeg": case ".png": case ".gif":
                    case ".bmp": case ".tiff": case ".svg":
                        state.isVideoExt = false;
                        break;
                    case ".mp4": case ".avi": case ".mov": case ".wmv":
                    case ".flv": case ".mkv": case ".webm": case ".mpg":
                    case ".mpeg":
                        state.isVideoExt = true;
                        break;
                    default:
                        break;
                }
            }
        };
        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:
                        router.replace('/youtube/list');
                        break;

                    default:
                        break;
                }
            }
        };
        return {
            state,
            modal,
            content,
            router,
            goToList,
            pushLike,
            pushBad,
            nextPage,
            prevPage,
            modalClose,
        };
    },
};
</script>
<style scoped>
.likeAndBad {
    margin: 5px;
}

.likeAndBad>label {
    border: 1px solid;
}

.action {
    background-color: gray;
}

.video-container {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
}

.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
